import { CSSProp } from 'styled-components';
import React from 'react';
import classNames from 'classnames';
import absoluteUrl from '@sls-react/utils/absoluteUrl';

export interface AnchorProps extends Omit<Props, 'href'> {}

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  as?: string | React.ComponentType;
  css?: CSSProp;
};

const A: React.FC<Props> = ({ as, children, className, href, ...props }) => {
  const computedHref =
    typeof href === 'string' && href.startsWith('http')
      ? href
      : absoluteUrl(href);

  return (
    <a
      className={classNames(
        'hover:text-blue-500 transition duration-200',
        className,
      )}
      href={computedHref}
      {...props}
    >
      {children}
    </a>
  );
};

export default A;
